// src/services/ganttDataUtilsService.ts
import { gantt } from 'dhtmlx-gantt';
import GanttService from './ganttService';
import cloneDeep from 'lodash.clonedeep';

interface LayerData {
  LayerId: number;
  Color: string;
  IsDefault: boolean;
  IsEnable: boolean;
  Name: string;
  TextColor: string;
  PriorityInConfigValue: number;
}

interface LayersByConversationEntry {
  layers: LayerData[];
}

interface ObjDataItem {
  LayerId: number;
  Name: string;
  Color: string;
  Type: string;
  Value: any;
  BasicFieldId: number;
  CustomFieldValueId: number;
  SelectedValuesText?: string;
}

interface StatusOption {
  key: number;
  label: string;
  basicfieldid: number;
}

interface OpenRowEntry {
  idOpen: number;
  openOrClose: boolean;
}

interface LayerDropdownItem {
  LayerId: number;
  Name: string;
}

interface DateValueResult {
  startDate: Date;
  endDate: Date;
  estimate: any;
  duration: any;
  strStartDate: string;
  strEndDate: string;
}

class ganttDataUtilsService
{
  static layersByConversation: Record<string, LayersByConversationEntry> = {};
  static CustomFieldLayers: any = {};
  static conversationsCount: number = 0;
  static layersIdOrdered: number[] = [];
  static layersToHide: string = '';
  static conversations: any[] = [];
  static data: any = {};
  static tasks: any[] = [];
  static props: any = [];
  static ListOpenRow: OpenRowEntry[] = [];
  static statusOptions: StatusOption[] = [];
  static basicFieldIds: number[] = [];
  static layerDropdown: LayerDropdownItem[] = [{ LayerId: 0, Name: 'All Layers' }];
  static appendtasks: any[] = [];

  static clearAll(): void
  {
    ganttDataUtilsService.layersByConversation = {};
    ganttDataUtilsService.layersIdOrdered = [];
    ganttDataUtilsService.conversations = [];
    ganttDataUtilsService.data = {};
    ganttDataUtilsService.tasks = [];
    ganttDataUtilsService.layerDropdown = [{ LayerId: 0, Name: 'All Layers' }];
    ganttDataUtilsService.appendtasks = [];
    ganttDataUtilsService.statusOptions = [];
    ganttDataUtilsService.basicFieldIds = [];
  }

  static getData(): any
  {
    ganttDataUtilsService.data = {
      tasks: ganttDataUtilsService.tasks,
    };
    return ganttDataUtilsService.data;
  }

  static updateDateTask(idParent: number): void
  {
    const FirstTasks = ganttDataUtilsService.tasks.filter((x: any) => x.parent == idParent);
    FirstTasks.forEach((f: any) =>
    {
      const nextTasks = ganttDataUtilsService.tasks.filter((x: any) => x.parent == f.id);
      const parentTask = nextTasks.filter((x: any) => x.order == 99);
      if (parentTask.length > 0)
      {
        parentTask.forEach((p: any) =>
        {
          this.updateDateTask(p.id);
        });
        const nextTasksFiltered = ganttDataUtilsService.tasks.filter(
          (x: any) => x.parent == f.id && x.duration != '',
        );
        const nextTasksHours = ganttDataUtilsService.tasks.filter((x: any) => x.parent == f.id);

        if (nextTasksFiltered.length > 0)
        {
          nextTasksFiltered.sort((a: any, b: any) => (a.start_date > b.start_date ? 1 : -1));
          f.start_date = nextTasksFiltered[0].start_date;
          f.a_start_date = nextTasksFiltered[0].a_start_date;
          nextTasksFiltered.sort((a: any, b: any) => (a.end_date < b.end_date ? 1 : -1));
          f.a_due_date = nextTasksFiltered[0].a_due_date;
          f.end_date = nextTasksFiltered[0].end_date;
          f.duration = this.count(nextTasksHours, 'duration');
          f.estimate = this.count(nextTasksHours, 'estimate');
        }
      }
    });

    if (idParent > 0)
    {
      const c = ganttDataUtilsService.tasks.filter((x: any) => x.id == idParent);
      const firstTasksFiltered = ganttDataUtilsService.tasks.filter(
        (x: any) => x.parent == idParent && x.duration != '',
      );
      const firstTasksHours = ganttDataUtilsService.tasks.filter((x: any) => x.parent == idParent);
      if (firstTasksFiltered.length > 0)
      {
        firstTasksFiltered.sort((a: any, b: any) => (a.start_date > b.start_date ? 1 : -1));
        c[0].start_date = firstTasksFiltered[0].start_date;
        c[0].a_start_date = firstTasksFiltered[0].a_start_date;
        firstTasksFiltered.sort((a: any, b: any) => (a.end_date < b.end_date ? 1 : -1));
        c[0].a_due_date = firstTasksFiltered[0].a_due_date;
        c[0].end_date = firstTasksFiltered[0].end_date;
        c[0].duration = this.count(firstTasksHours, 'duration');
        c[0].estimate = this.count(firstTasksHours, 'estimate');
      }
    }
  }

  static updateAppendTask(idParent: number): void
  {
    const FirstTasks = ganttDataUtilsService.appendtasks.filter((x: any) => x.parent == idParent);
    FirstTasks.forEach((f: any) =>
    {
      let nextTasks = ganttDataUtilsService.appendtasks.filter((x: any) => x.parent == f.id);
      const parentTask = nextTasks.filter((x: any) => x.order == 99);
      if (parentTask.length > 0)
      {
        parentTask.forEach((p: any) =>
        {
          this.updateAppendTask(p.id);
        });

        nextTasks = ganttDataUtilsService.appendtasks.filter((x: any) => x.parent == f.id);
        nextTasks.sort((a: any, b: any) => (a.start_date > b.start_date ? 1 : -1));
        f.start_date = nextTasks[0].start_date;
        f.a_start_date = nextTasks[0].a_start_date;
        nextTasks.sort((a: any, b: any) => (a.end_date < b.end_date ? 1 : -1));
        f.a_due_date = nextTasks[0].a_due_date;
        f.end_date = nextTasks[0].end_date;
        f.duration = this.count(nextTasks, 'duration');
        f.estimate = this.count(nextTasks, 'estimate');
      }
    });

    if (idParent > 0)
    {
      const c = ganttDataUtilsService.appendtasks.filter((x: any) => x.id == idParent);
      const firstTasks = ganttDataUtilsService.appendtasks.filter((x: any) => x.parent == idParent);
      firstTasks.sort((a: any, b: any) => (a.start_date > b.start_date ? 1 : -1));
      c[0].start_date = firstTasks[0].start_date;
      c[0].a_start_date = firstTasks[0].a_start_date;
      firstTasks.sort((a: any, b: any) => (a.end_date < b.end_date ? 1 : -1));
      c[0].a_due_date = firstTasks[0].a_due_date;
      c[0].end_date = firstTasks[0].end_date;
      c[0].duration = this.count(firstTasks, 'duration');
      c[0].estimate = this.count(firstTasks, 'estimate');
    }
  }

  static count(array: any[], key: string): number
  {
    return array.reduce(function (r: number, a: any)
    {
      return r + (a[key] == '' || a[key] == undefined ? 0 : a[key]);
    }, 0);
  }

  static pushConversation(item: any): void
  {
    ganttDataUtilsService.conversations.push(item);
  }

  static getDataFromDashboardResponse(response: any, selectedLayer: number, props: any): void
  {
    ganttDataUtilsService.clearAll();

    ganttDataUtilsService.props = props;
    const conversations = response.Conversations;
    for (let x = 0; x < conversations.length; x++)
    {
      ganttDataUtilsService.processConversation(conversations[x], selectedLayer, false);
    }

    setTimeout(function ()
    {
      const parentOfPhasesConversations = ganttDataUtilsService.tasks.filter(
        (task: any) => task.hasPhases == true,
      );

      for (let i = 0; i < parentOfPhasesConversations.length; i++)
      {
        ganttDataUtilsService.updateParentTree(parentOfPhasesConversations[i].id);
      }
    });

    this.updateDateTask(0);

    ganttDataUtilsService.tasks.sort((a: any, b: any) => (a.order > b.order ? 1 : -1));
    ganttDataUtilsService.tasks = ganttDataUtilsService.tasks.reverse();
    conversations.forEach(ganttDataUtilsService.pushConversation);
  }

  static addLayer(layer: any): void
  {
    const ConversationId = layer.ConversationId;
    const currentConversation =
      ganttDataUtilsService.layersByConversation[ConversationId.toString()];
    if (currentConversation === undefined)
    {
      const keyid = ConversationId.toString();
      const newItem: LayersByConversationEntry = {
        layers: [
          {
            LayerId: layer.LayerId,
            Color: layer.LayerColor,
            IsDefault: layer.IsDefault,
            IsEnable: layer.IsEnable,
            Name: layer.LayerName,
            TextColor: layer.LayerColor,
            PriorityInConfigValue: layer.PriorityInConfigValue,
          },
        ],
      };
      ganttDataUtilsService.layersByConversation[keyid] = newItem;
    }
    else
    {
      let flag = false;
      for (let i = 0; i < currentConversation.layers.length; i++)
      {
        if (currentConversation.layers[i]!.LayerId === layer.LayerId)
        {
          flag = true;
          break;
        }
      }
      if (!flag)
      {
        currentConversation.layers.push({
          LayerId: layer.LayerId,
          Color: layer.LayerColor,
          IsDefault: layer.IsDefault,
          IsEnable: layer.IsEnable,
          Name: layer.LayerName,
          TextColor: layer.LayerColor,
          PriorityInConfigValue: layer.PriorityInConfigValue,
        });
      }
    }
  }

  static getThreeMostPriorityLayersColors(layers: LayerData[]): string[]
  {
    layers.sort(function (a, b)
    {
      return a.PriorityInConfigValue - b.PriorityInConfigValue;
    });
    return layers.map(x => x.Color);
  }

  static appendDataFromResponse(
    index: number,
    response: any,
    selectedLayer: number,
    props: any,
  ): void
  {
    ganttDataUtilsService.appendtasks = [];
    const conversations = response.Conversations;
    ganttDataUtilsService.props = props;

    for (let x = 0; x < conversations.length; x++)
    {
      ganttDataUtilsService.processConversation(conversations[x], selectedLayer, true);
      index = index + 1;
    }
    this.updateAppendTask(0);
    ganttDataUtilsService.appendtasks.sort((a: any, b: any) => (a.order > b.order ? 1 : -1));
    ganttDataUtilsService.appendtasks = ganttDataUtilsService.appendtasks.reverse();

    ganttDataUtilsService.appendtasks.forEach((task: any) =>
    {
      ganttDataUtilsService.tasks.push(task);
    });
    conversations.forEach(ganttDataUtilsService.pushConversation);
  }

  static processConversation(item: any, selectedLayer: number, isAppendTask: boolean): void
  {
    if (selectedLayer > 0)
    {
      ganttDataUtilsService.getlayersfromconversationOneLayer(item, selectedLayer, isAppendTask);
    }
    else
    {
      ganttDataUtilsService.getlayersfromconversation(item, isAppendTask);
    }
  }

  static getlayersfromconversation(item: any, isAppendTask: boolean): void
  {
    if (item && item.ConversationId)
    {
      const phasesConversation = item.Conversations;
      const layers = item.CustomFieldLayers;
      const conversationLayers = item.ConversationLayers;
      const layersToHideArray = ganttDataUtilsService.layersToHide.split(',');
      const arrayStartDate: string[] = [];
      const arrayDueDate: string[] = [];
      let sumEstimate = 0;
      const objData: ObjDataItem[] = [];
      const objLayer: number[] = [];

      for (let k = 0; k < conversationLayers.length; k++)
      {
        ganttDataUtilsService.addLayer(conversationLayers[k]);
      }

      for (let i = 0; i < layers.length; i++)
      {
        if (layersToHideArray.indexOf(layers[i].LayerId.toString()) == -1)
        {
          if (!ganttDataUtilsService.layersIdOrdered.includes(layers[i].LayerId))
            ganttDataUtilsService.layersIdOrdered.push(layers[i].LayerId);

          layers[i].CustomFields.sort((a: any, b: any) =>
          {
            if (a.OrderInLayer >= b.OrderInLayer)
            {
              if (a.OrderInLayer === b.OrderInLayer)
              {
                return a.CustomFieldId >= b.CustomFieldId ? 1 : -1;
              }
              else return 1;
            }
            else return -1;
          });

          for (let j = 0; j < layers[i].CustomFields.length; j++)
          {
            if (objLayer.indexOf(layers[i].LayerId) === -1)
            {
              objLayer.push(layers[i].LayerId);
            }

            if (layers[i].CustomFields[j].Name == 'Start date')
            {
              objData.push({
                LayerId: layers[i].LayerId,
                Name: layers[i].Name,
                Color: layers[i].Color,
                Type: 'Start date',
                Value:
                  layers[i].CustomFields[j].Value == null ? '' : layers[i].CustomFields[j].Value,
                BasicFieldId: layers[i].CustomFields[j].BasicFieldId,
                CustomFieldValueId: layers[i].CustomFields[j].CustomFieldValueId,
              });
            }
            else if (layers[i].CustomFields[j].Name == 'Due date')
            {
              objData.push({
                LayerId: layers[i].LayerId,
                Name: layers[i].Name,
                Color: layers[i].Color,
                Type: 'Due date',
                Value:
                  layers[i].CustomFields[j].Value == null ? '' : layers[i].CustomFields[j].Value,
                BasicFieldId: layers[i].CustomFields[j].BasicFieldId,
                CustomFieldValueId: layers[i].CustomFields[j].CustomFieldValueId,
              });
            }
            else if (layers[i].CustomFields[j].Name == 'Estimated')
            {
              objData.push({
                LayerId: layers[i].LayerId,
                Name: layers[i].Name,
                Color: layers[i].Color,
                Type: 'Estimated',
                Value:
                  layers[i].CustomFields[j].Value == null || layers[i].CustomFields[j].Value == ''
                    ? ''
                    : parseFloat(layers[i].CustomFields[j].Value),
                BasicFieldId: layers[i].CustomFields[j].BasicFieldId,
                CustomFieldValueId: layers[i].CustomFields[j].CustomFieldValueId,
              });
            }
            else if (layers[i].CustomFields[j].Name == 'Status')
            {
              objData.push({
                LayerId: layers[i].LayerId,
                Name: layers[i].Name,
                Color: layers[i].Color,
                Type: 'Status',
                Value:
                  layers[i].CustomFields[j].Value == null ? '' : layers[i].CustomFields[j].Value,
                BasicFieldId: layers[i].CustomFields[j].BasicFieldId,
                CustomFieldValueId: layers[i].CustomFields[j].CustomFieldValueId,
                SelectedValuesText:
                  layers[i].CustomFields[j].SelectedValuesText == null
                    ? ''
                    : layers[i].CustomFields[j].SelectedValuesText,
              });
            }
          }
        }
      }

      objData.sort((a, b) => (a.CustomFieldValueId < b.CustomFieldValueId ? 1 : -1));

      for (let i = 0; i < objLayer.length; i++)
      {
        const layer = objData.filter(x => x.LayerId == objLayer[i]);
        const start_date = layer.filter(x => x.Type == 'Start date');
        const end_date = layer.filter(x => x.Type == 'Due date');
        const n_estimate = layer.filter(x => x.Type == 'Estimated');

        if (start_date.length > 0 && end_date.length > 0 && n_estimate.length > 0)
        {
          if (start_date[0]!.Value !== null && start_date[0]!.Value !== '')
            arrayStartDate.push(start_date[0]!.Value);

          if (end_date[0]!.Value !== null && end_date[0]!.Value !== '')
            arrayDueDate.push(end_date[0]!.Value);

          if (n_estimate[0]!.Value !== null && n_estimate[0]!.Value !== '')
            sumEstimate = sumEstimate + parseFloat(n_estimate[0]!.Value);
        }
      }

      const sortedStartDate = arrayStartDate.sort(function (a, b)
      {
        return new Date(a).getTime() - new Date(b).getTime();
      });

      const sortedDueDate = arrayDueDate.sort(function (a, b)
      {
        return new Date(b).getTime() - new Date(a).getTime();
      });

      const data = this.getDateValue(
        sortedStartDate[0] == undefined ||
          sortedStartDate[0] == null ||
          sortedStartDate[0] == '' ||
          sortedStartDate[0] == 'Not Set'
          ? undefined
          : new Date(sortedStartDate[0]),
        sortedDueDate[0] == undefined ||
          sortedDueDate[0] == null ||
          sortedDueDate[0] == '' ||
          sortedDueDate[0] == 'Not Set'
          ? undefined
          : new Date(sortedDueDate[0]),
        sumEstimate,
        '',
      );

      const render = this.getTitleRender(item, 0);
      const identificador = item.ConversationId;

      const darkMode = localStorage.getItem('ls.C2_enableDarkMode');

      const tasks = {
        id: identificador,
        text: item.Title,
        start_date: data.startDate,
        end_date: data.endDate,
        duration: data.duration,
        estimate: data.estimate,
        hasStatus: true,
        render: render,
        taskupdate: '',
        color: darkMode == 'true' ? '#363737' : '#f9f9f9',
        a_due_date: data.strEndDate,
        a_start_date: data.strStartDate,
        readonly: true,
        parent: item.PhaseOfConversationId ? item.PhaseOfConversationId : item.ParentConversationId,
        order: item.ParentConversationId > 0 ? 99 : 0,
        hasPhases: phasesConversation && phasesConversation.length > 0,
      };

      if (isAppendTask)
      {
        ganttDataUtilsService.appendtasks.push(tasks);
      }
      else
      {
        ganttDataUtilsService.tasks.push(tasks);
      }

      if (phasesConversation && phasesConversation.length > 0)
      {
        for (let i = 0; i < phasesConversation.length; i++)
        {
          this.getlayersfromconversation(phasesConversation[i], isAppendTask);
        }
      }
      else
      {
        for (let i = 0; i < objLayer.length; i++)
        {
          const layer = objData.filter(x => x.LayerId == objLayer[i]);
          const start_date = layer.filter(x => x.Type == 'Start date');
          const end_date = layer.filter(x => x.Type == 'Due date');
          const n_estimate = layer.filter(x => x.Type == 'Estimated');
          const status = layer.filter(x => x.Type == 'Status');
          let hasStatus = false;

          if (status && status.length > 0)
          {
            hasStatus = true;
            if (!ganttDataUtilsService.basicFieldIds.includes(status[0]!.BasicFieldId))
            {
              ganttDataUtilsService.basicFieldIds.push(status[0]!.BasicFieldId);

              GanttService.GetBasicFieldValueById(status[0]!.BasicFieldId).then(function (
                response: any,
              )
              {
                for (let h = 0; h < response.length; h++)
                {
                  if (response[h].Name)
                  {
                    ganttDataUtilsService.statusOptions.push({
                      key: response[h].BasicFieldValueId,
                      label: response[h].Name,
                      basicfieldid: response[h].BasicFieldId,
                    });
                  }
                }
              });
            }
          }

          if (start_date.length > 0 && end_date.length > 0 && n_estimate.length > 0)
          {
            const layerData = this.getDateValue(
              start_date[0]!.Value == undefined ||
                start_date[0]!.Value == null ||
                start_date[0]!.Value == '' ||
                start_date[0]!.Value == 'Not Set' ||
                !this.isValidDate(start_date[0]!.Value)
                ? undefined
                : new Date(start_date[0]!.Value),
              end_date[0]!.Value == undefined ||
                end_date[0]!.Value == null ||
                end_date[0]!.Value == '' ||
                end_date[0]!.Value == 'Not Set' ||
                !this.isValidDate(end_date[0]!.Value)
                ? undefined
                : new Date(end_date[0]!.Value),
              item.IsProjectConversation ? '' : n_estimate[0]!.Value,
              '',
            );

            if (layer[0]!.LayerId != 0)
            {
              if (!ganttDataUtilsService.layerDropdown.some(l => l.LayerId == layer[0]!.LayerId))
                ganttDataUtilsService.layerDropdown.push({
                  LayerId: layer[0]!.LayerId,
                  Name: layer[0]!.Name,
                });
            }

            const subtasks = {
              id: identificador + '_' + objLayer[i],
              text: layer[0]!.Name,
              start_date: layerData.startDate,
              end_date: layerData.endDate,
              duration: layerData.duration,
              estimate: layerData.estimate,
              status: status && status.length > 0 ? status[0]!.Value : '',
              statusText: status && status.length > 0 ? status[0]!.SelectedValuesText : '',
              hasStatus: hasStatus,
              parent: identificador,
              render:
                '<span class="gantt-layer-tag" style="background-color: ' +
                layer[0]!.Color +
                '"></span><span class="gantt_subtitle">' +
                layer[0]!.Name +
                '</span>',
              color: layer[0]!.Color,
              taskupdate: '',
              conversationId: item.ConversationId,
              IsProjectConversation: item.IsProjectConversation,
              layerId: layer[0]!.LayerId,
              b_start_date: start_date[0]!.BasicFieldId,
              b_due_date: end_date[0]!.BasicFieldId,
              b_estimated: item.IsProjectConversation ? '' : n_estimate[0]!.BasicFieldId,
              b_status: status && status.length > 0 ? status[0]!.BasicFieldId : '',
              a_due_date: layerData.strEndDate,
              a_start_date: layerData.strStartDate,
              b_start_date_cfvId: start_date[0]!.CustomFieldValueId,
              b_due_date_cfvId: end_date[0]!.CustomFieldValueId,
              b_estimate_cfvId: n_estimate[0]!.CustomFieldValueId,
              b_status_cfvId: status && status.length > 0 ? status[0]!.CustomFieldValueId : '',
              order: 0,
            };

            if (isAppendTask) ganttDataUtilsService.appendtasks.push(subtasks);
            else ganttDataUtilsService.tasks.push(subtasks);
          }
        }
      }
    }
  }

  static getlayersfromconversationOneLayer(
    item: any,
    selectedLayer: number,
    isAppendTask: boolean,
  ): void
  {
    if (item && item.ConversationId)
    {
      const phasesConversation = item.Conversations;
      const layers = item.CustomFieldLayers;
      const render = this.getTitleRender(item, selectedLayer);
      const identificador = item.ConversationId;
      const conversationLayers = item.ConversationLayers;
      const layersToHideArray = ganttDataUtilsService.layersToHide.split(',');
      const objData: ObjDataItem[] = [];
      const objLayer: number[] = [];

      for (let k = 0; k < conversationLayers.length; k++)
      {
        ganttDataUtilsService.addLayer(conversationLayers[k]);
      }

      for (let i = 0; i < layers.length; i++)
      {
        if (layersToHideArray.indexOf(layers[i].LayerId.toString()) == -1)
        {
          if (!ganttDataUtilsService.layersIdOrdered.includes(layers[i].LayerId))
            ganttDataUtilsService.layersIdOrdered.push(layers[i].LayerId);

          layers[i].CustomFields.sort((a: any, b: any) =>
          {
            if (a.OrderInLayer >= b.OrderInLayer)
            {
              if (a.OrderInLayer === b.OrderInLayer)
              {
                return a.CustomFieldId >= b.CustomFieldId ? 1 : -1;
              }
              else return 1;
            }
            else return -1;
          });

          for (let j = 0; j < layers[i].CustomFields.length; j++)
          {
            if (objLayer.indexOf(layers[i].LayerId) === -1)
            {
              objLayer.push(layers[i].LayerId);
            }

            if (layers[i].CustomFields[j].Name == 'Start date')
            {
              objData.push({
                LayerId: layers[i].LayerId,
                Name: layers[i].Name,
                Color: layers[i].Color,
                Type: 'Start date',
                Value:
                  layers[i].CustomFields[j].Value == null ? '' : layers[i].CustomFields[j].Value,
                BasicFieldId: layers[i].CustomFields[j].BasicFieldId,
                CustomFieldValueId: layers[i].CustomFields[j].CustomFieldValueId,
              });
            }
            else if (layers[i].CustomFields[j].Name == 'Due date')
            {
              objData.push({
                LayerId: layers[i].LayerId,
                Name: layers[i].Name,
                Color: layers[i].Color,
                Type: 'Due date',
                Value:
                  layers[i].CustomFields[j].Value == null ? '' : layers[i].CustomFields[j].Value,
                BasicFieldId: layers[i].CustomFields[j].BasicFieldId,
                CustomFieldValueId: layers[i].CustomFields[j].CustomFieldValueId,
              });
            }
            else if (layers[i].CustomFields[j].Name == 'Estimated')
            {
              objData.push({
                LayerId: layers[i].LayerId,
                Name: layers[i].Name,
                Color: layers[i].Color,
                Type: 'Estimated',
                Value:
                  layers[i].CustomFields[j].Value == null ||
                  layers[i].CustomFields[j].Value == '' ||
                  layers[i].CustomFields[j].Value === 0
                    ? layers[i].CustomFields[j].Value === 0
                      ? 0
                      : ''
                    : parseFloat(layers[i].CustomFields[j].Value),
                BasicFieldId: layers[i].CustomFields[j].BasicFieldId,
                CustomFieldValueId: layers[i].CustomFields[j].CustomFieldValueId,
              });
            }
            else if (layers[i].CustomFields[j].Name == 'Status')
            {
              objData.push({
                LayerId: layers[i].LayerId,
                Name: layers[i].Name,
                Color: layers[i].Color,
                Type: 'Status',
                Value:
                  layers[i].CustomFields[j].Value == null ? '' : layers[i].CustomFields[j].Value,
                BasicFieldId: layers[i].CustomFields[j].BasicFieldId,
                CustomFieldValueId: layers[i].CustomFields[j].CustomFieldValueId,
                SelectedValuesText:
                  layers[i].CustomFields[j].SelectedValuesText == null
                    ? ''
                    : layers[i].CustomFields[j].SelectedValuesText,
              });
            }
          }
        }
      }

      objData.sort((a, b) => (a.CustomFieldValueId < b.CustomFieldValueId ? 1 : -1));

      for (let i = 0; i < objLayer.length; i++)
      {
        const layer = objData.filter(x => x.LayerId == objLayer[i]);
        const start_date = layer.filter(x => x.Type == 'Start date');
        const end_date = layer.filter(x => x.Type == 'Due date');
        const n_estimate = layer.filter(x => x.Type == 'Estimated');
        const status = layer.filter(x => x.Type == 'Status');
        let hasStatus = false;

        if (status && status.length > 0)
        {
          hasStatus = true;
          if (!ganttDataUtilsService.basicFieldIds.includes(status[0]!.BasicFieldId))
          {
            ganttDataUtilsService.basicFieldIds.push(status[0]!.BasicFieldId);

            GanttService.GetBasicFieldValueById(status[0]!.BasicFieldId).then(function (
              response: any,
            )
            {
              for (let h = 0; h < response.length; h++)
              {
                if (response[h].Name)
                {
                  ganttDataUtilsService.statusOptions.push({
                    key: response[h].BasicFieldValueId,
                    label: response[h].Name,
                    basicfieldid: response[h].BasicFieldId,
                  });
                }
              }
            });
          }
        }

        if (start_date.length > 0 && end_date.length > 0 && n_estimate.length > 0)
        {
          const layerData = this.getDateValue(
            start_date[0]!.Value == undefined ||
              start_date[0]!.Value == null ||
              start_date[0]!.Value == '' ||
              start_date[0]!.Value == 'Not Set' ||
              !this.isValidDate(start_date[0]!.Value)
              ? undefined
              : new Date(start_date[0]!.Value),
            end_date[0]!.Value == undefined ||
              end_date[0]!.Value == null ||
              end_date[0]!.Value == '' ||
              end_date[0]!.Value == 'Not Set' ||
              !this.isValidDate(end_date[0]!.Value)
              ? undefined
              : new Date(end_date[0]!.Value),
            item.IsProjectConversation ? '' : n_estimate[0]!.Value,
            '',
          );

          if (layer[0]!.LayerId != 0)
          {
            if (!ganttDataUtilsService.layerDropdown.some(l => l.LayerId == layer[0]!.LayerId))
              ganttDataUtilsService.layerDropdown.push({
                LayerId: layer[0]!.LayerId,
                Name: layer[0]!.Name,
              });
          }

          if (layer[0]!.LayerId == selectedLayer)
          {
            const subtasks = {
              id: identificador,
              text: item.Title,
              render: render,
              start_date: layerData.startDate,
              end_date: layerData.endDate,
              duration: layerData.duration,
              estimate: layerData.estimate,
              status: status && status.length > 0 ? status[0]!.Value : '',
              statusText: status && status.length > 0 ? status[0]!.SelectedValuesText : '',
              hasStatus: hasStatus,
              color: layer[0]!.Color,
              taskupdate: '',
              conversationId: item.ConversationId,
              IsProjectConversation: item.IsProjectConversation,
              layerId: layer[0]!.LayerId,
              b_start_date: start_date[0]!.BasicFieldId,
              b_due_date: end_date[0]!.BasicFieldId,
              b_estimated: item.IsProjectConversation ? '' : n_estimate[0]!.BasicFieldId,
              b_status: status && status.length > 0 ? status[0]!.BasicFieldId : '',
              a_due_date: layerData.strEndDate,
              a_start_date: layerData.strStartDate,
              b_start_date_cfvId: start_date[0]!.CustomFieldValueId,
              b_due_date_cfvId: end_date[0]!.CustomFieldValueId,
              b_estimate_cfvId: n_estimate[0]!.CustomFieldValueId,
              b_status_cfvId: status && status.length > 0 ? status[0]!.CustomFieldValueId : '',
              parent: item.PhaseOfConversationId
                ? item.PhaseOfConversationId
                : item.ParentConversationId,
              order: item.ParentConversationId > 0 ? 99 : 0,
              hasPhases: phasesConversation && phasesConversation.length > 0,
            };

            if (isAppendTask) ganttDataUtilsService.appendtasks.push(subtasks);
            else ganttDataUtilsService.tasks.push(subtasks);

            if (phasesConversation && phasesConversation.length > 0)
            {
              for (let i = 0; i < phasesConversation.length; i++)
              {
                this.getlayersfromconversationOneLayer(
                  phasesConversation[i],
                  selectedLayer,
                  isAppendTask,
                );
              }
            }
          }
        }
      }
    }
  }

  static updateCustomDetail(
    indexConversation: number,
    indexLayer: number,
    indexCustomField: number,
    item: any,
  ): void
  {
    const customField =
      ganttDataUtilsService.conversations[indexConversation].CustomFieldLayers[indexLayer]
        .CustomFields[indexCustomField];
    customField.CoreTaskId = item.CoreTaskId;
    customField.CustomFieldId = item.CustomFieldId;
    customField.CustomFieldValueId = item.CustomFieldValueId;
    customField.PreviousValue = item.PreviousValue;
    customField.ProjectId = item.ProjectId;
    customField.SelectedValuesText = item.SelectedValuesText;
    customField.Value = item.Value;
    customField.ValueField = item.ValueField;
    ganttDataUtilsService.conversations[indexConversation].CustomFieldLayers[
      indexLayer
    ].CustomFields[indexCustomField] = customField;
  }

  static duration(date1: Date, date2: Date): number
  {
    date2.setHours(23, 0, 0, 0);
    return gantt.calculateDuration(date1, date2);
  }

  static getThreeLayers(ConversationId: number): string[]
  {
    const conversationLayers =
      ganttDataUtilsService.layersByConversation[ConversationId.toString()];
    let layers: string[] = [];
    if (conversationLayers != undefined)
      layers = ganttDataUtilsService.getThreeMostPriorityLayersColors(conversationLayers.layers);
    else layers.push('');
    return layers;
  }

  static isValidDate(dateStr: string): boolean
  {
    const regex = /^(\d{2})\/(\d{2})\/(\d{4})$/;
    const match = dateStr.match(regex);
    if (!match) return false;

    const day = parseInt(match[1]!, 10);
    const month = parseInt(match[2]!, 10);
    const year = parseInt(match[3]!, 10);

    if (month < 1 || month > 12) return false;

    const daysInMonth = new Date(year, month, 0).getDate();

    if (day < 1 || day > daysInMonth) return false;

    return true;
  }

  static getStartDateValid(due_date: any): Date
  {
    const returnDate = new Date();
    if (due_date == undefined || due_date == '' || due_date == null)
      returnDate.setHours(0, 0, 0, 0);
    else
    {
      returnDate.setDate(returnDate.getDate() - 1);
    }
    return returnDate;
  }

  static getDueDateValid(start_date: any, estimate: any): Date
  {
    let returnDate = new Date();
    if (start_date == undefined || start_date == '' || start_date == null)
      returnDate.setHours(1, 0, 0, 0);
    else
    {
      returnDate = new Date(start_date);
      if (estimate == '' || estimate == 0)
      {
        returnDate.setHours(23, 0, 0, 0);
      }
      else
      {
        estimate = estimate * 3;
        estimate = estimate > 23 ? estimate - 1 : estimate;
        returnDate = gantt.calculateEndDate(returnDate, estimate, 'hour');
      }
    }
    return returnDate;
  }

  static getTitleRender(item: any, selectedLayer: number): string
  {
    let color = '';

    const styleIsRedFlag = item.IsRedFlag ? 'style ="color:#e14949;"' : '';
    let render = '';
    const sectionImportant =
      item.IsImportant == true
        ? '<div class="placeholder-triangule triangule-gantt-important"></div>'
        : '<div class="placeholder-triangule"></div>';

    if (selectedLayer == 0)
    {
      render =
        '<div data-id="' +
        item.ConversationId +
        '" data-title="' +
        item.Title +
        '" class="gantt-widget"><div class="gantt-header-elements-widget">' +
        (item.PhaseOfConversationId
          ? ''
          : '<div class="gantt-layout-without-image gantt-has-checkbox">' +
            '<div class="gantt-header-icons"><span class="identifier-icon-key ' +
            item.Icon +
            ' " ></span></div>' +
            '</div>') +
        '<div class="gantt-header-center-section"><span class="gantt-task-name-widget">' +
        '<span class="' +
        (item.PhaseOfConversationId
          ? 'task-name-phase"><span '
          : 'task-name"><span ' + styleIsRedFlag) +
        ' class="task-title ' +
        (item.PhaseOfConversationId ? 'gantt-task-title-phase' : 'gantt-task-title') +
        '" conversation-id="' +
        item.ConversationId +
        '">' +
        item.Title +
        '</span></span>' +
        '</span>' +
        sectionImportant +
        '</div>' +
        '</div></div>';
    }
    else
    {
      for (let i = 0; i <= item.CustomFieldLayers.length - 1; i++)
      {
        if (item.CustomFieldLayers[i].LayerId == selectedLayer)
        {
          color = item.CustomFieldLayers[i].Color;
        }
      }

      render =
        '<div data-id="' +
        item.ConversationId +
        '" data-title="' +
        item.Title +
        '" class="gantt-widget"><div class="gantt-header-elements-widget">' +
        (item.PhaseOfConversationId
          ? ''
          : '<div class="gantt-layout-without-image gantt-has-checkbox">') +
        '<span class="gantt-layer-tag" style="background-color: ' +
        color +
        '; margin-top: 2px;">' +
        (item.PhaseOfConversationId
          ? ''
          : '<div class="gantt-header-icons"><span class="identifier-icon-key ' +
            item.Icon +
            ' " ></span></div>') +
        (item.PhaseOfConversationId ? '' : '</div>') +
        '<div class="gantt-header-center-section"><span class="gantt-task-name-widget">' +
        '<span class="' +
        (item.PhaseOfConversationId
          ? 'task-name-phase"><span '
          : 'task-name"><span ' + styleIsRedFlag) +
        ' class="task-title ' +
        (item.PhaseOfConversationId ? 'gantt-task-title-phase' : 'gantt-task-title') +
        '" conversation-id="' +
        item.ConversationId +
        '">' +
        item.Title +
        '</span></span>' +
        '</span>' +
        sectionImportant +
        '</div>' +
        '</span>' +
        '</div></div>';
    }

    return render;
  }

  static getDateValue(
    startDate: Date | undefined,
    endDate: Date | undefined,
    estimate: any,
    duration: any,
  ): DateValueResult
  {
    const Data: any = {};
    const today = new Date();

    if (startDate == undefined && endDate == undefined)
    {
      const date1 = new Date();
      const date2 = new Date();
      Data.startDate = new Date(date1.setHours(0, 0, 0, 0));
      Data.endDate = new Date(date2.setHours(0, 0, 0, 0));
      Data.estimate = estimate;
      Data.duration = duration;
      Data.strStartDate = '';
      Data.strEndDate = '';
    }
    else if (startDate == undefined && endDate != undefined)
    {
      if (estimate > 5000) estimate = 5000;

      let date1: Date;
      if (estimate > 0)
      {
        date1 = new Date(endDate.setHours(23, 0, 0, 0));
        date1 = new Date(date1.setHours(date1.getHours() - estimate * 3 + 1));
        duration = gantt.calculateDuration(date1, new Date(endDate.setHours(23, 0, 0, 0)));
      }
      else
      {
        const yearLimit = today.getFullYear() + 20;
        const yearEndDate = endDate.getFullYear();
        if (yearEndDate > yearLimit) endDate = new Date(yearLimit, 2, 1);

        date1 = new Date(endDate.setHours(0, 0, 0, 0));
        duration = '';
      }
      Data.startDate = date1;
      Data.endDate = new Date(endDate.setHours(23, 0, 0, 0));
      Data.estimate = estimate;
      Data.duration = duration;
      Data.strStartDate = '';
      Data.strEndDate = this.formattedDate(endDate);
    }
    else if (startDate != undefined && endDate == undefined)
    {
      const yearLimit = today.getFullYear() - 20;
      const yearStartDate = startDate.getFullYear();
      if (yearStartDate < yearLimit) startDate = new Date(yearLimit, 2, 1);

      const date1 = this.formattedDate(startDate);
      Data.startDate = new Date(startDate.setHours(0, 0, 0, 0));
      Data.endDate = ganttDataUtilsService.getDueDateValid(date1, estimate);
      Data.strStartDate = date1;
      Data.strEndDate = '';
      Data.estimate = estimate;
      Data.duration = gantt.calculateDuration(Data.startDate, Data.endDate);
    }
    else
    {
      /* Both dates defined */
      let yearLimit = today.getFullYear() - 20;
      const yearStartDate = startDate!.getFullYear();
      if (yearStartDate < yearLimit) startDate = new Date(yearLimit, 2, 1);

      yearLimit = today.getFullYear() + 20;
      const yearEndDate = endDate!.getFullYear();
      if (yearEndDate > yearLimit) endDate = new Date(yearLimit, 2, 1);

      Data.startDate = new Date(startDate!.setHours(0, 0, 0, 0));
      Data.endDate = new Date(endDate!.setHours(23, 0, 0, 0));
      Data.duration = gantt.calculateDuration(Data.startDate, Data.endDate);
      if (estimate * 3 - 1 > Data.duration)
      {
        Data.estimate = estimate;
        Data.strStartDate = this.formattedDate(startDate!);
        Data.strEndDate = this.formattedDate(endDate!);
      }
      else
      {
        const hours = estimate * 3;
        Data.endDate = gantt.calculateEndDate(Data.startDate, hours - 1, 'hour');
        if (this.formattedDate(Data.endDate) == this.formattedDate(endDate!))
        {
          Data.duration = gantt.calculateDuration(Data.startDate, Data.endDate);
          Data.estimate = estimate;
          Data.strStartDate = this.formattedDate(startDate!);
          Data.strEndDate = this.formattedDate(endDate!);
        }
        else
        {
          Data.endDate = new Date(endDate!.setHours(23, 0, 0, 0));
          Data.duration = gantt.calculateDuration(Data.startDate, Data.endDate);
          Data.estimate = estimate;
          Data.strStartDate = this.formattedDate(startDate!);
          Data.strEndDate = this.formattedDate(endDate!);
        }
      }
    }
    return Data;
  }

  static formattedDate(d: Date): string
  {
    let month = String(d.getMonth() + 1);
    let day = String(d.getDate());
    const year = String(d.getFullYear());
    if (month.length < 2) month = '0' + month;
    if (day.length < 2) day = '0' + day;
    return month + '/' + day + '/' + year;
  }

  static updateOpenTask(id: any, openOrClose: boolean): void
  {
    const list = ganttDataUtilsService.ListOpenRow;
    if (list != null && list.length > 0)
    {
      const objRow = list.find(x => x.idOpen == id);
      if (objRow != null)
      {
        for (let i = 0; i <= list.length - 1; i++)
        {
          if (list[i]!.idOpen == id)
          {
            list[i]!.openOrClose = openOrClose;
          }
        }
        ganttDataUtilsService.ListOpenRow = list;
      }
      else
      {
        const openClose = {
          idOpen: parseInt(id),
          openOrClose: openOrClose,
        };
        ganttDataUtilsService.ListOpenRow.push(openClose);
      }
    }
    else
    {
      const openClose = {
        idOpen: parseInt(id),
        openOrClose: openOrClose,
      };
      ganttDataUtilsService.ListOpenRow.push(openClose);
    }
  }

  static updateParentTree(idparent: any): void
  {
    const children = gantt.getChildren(idparent);
    let startDate: Date[] = [];
    let endDate: Date[] = [];
    let sumEstimate = 0;
    const duration = '';

    for (let i = 0; i < children.length; i++)
    {
      if (gantt.getTask(children[i]).a_start_date !== '')
        startDate.push(gantt.getTask(children[i]).start_date!);
      if (gantt.getTask(children[i]).a_due_date !== '')
        endDate.push(gantt.getTask(children[i]).end_date!);
      sumEstimate =
        sumEstimate +
        parseFloat(
          gantt.getTask(children[i]).estimate == '' ? 0 : gantt.getTask(children[i]).estimate,
        );
    }

    startDate = startDate.sort(function (a, b)
    {
      return a.getTime() - b.getTime();
    });

    endDate = endDate.sort(function (a, b)
    {
      return b.getTime() - a.getTime();
    });
    const Copy_startDate = cloneDeep(startDate);
    const Copy_endDate = cloneDeep(endDate);
    const data = ganttDataUtilsService.getDateValue(
      Copy_startDate[0]!,
      Copy_endDate[0]!,
      Number(sumEstimate),
      duration,
    );
    gantt.getTask(idparent).start_date = data.startDate;
    gantt.getTask(idparent).end_date = data.endDate;
    gantt.getTask(idparent).a_start_date = data.strStartDate;
    gantt.getTask(idparent).a_due_date = data.strEndDate;
    gantt.getTask(idparent).duration = data.duration;
    gantt.getTask(idparent).estimate = Number(data.estimate);
    gantt.updateTask(idparent);
    gantt.refreshData();
    ganttDataUtilsService.updateTaskCache(idparent, true);
    gantt.render();
  }

  static updateTaskCache(id: any, isparent?: boolean): void
  {
    if (ganttDataUtilsService.tasks.length > 0)
    {
      let indextask: number;
      if (isparent == true)
      {
        indextask = ganttDataUtilsService.tasks.findIndex((x: any) => x.id === Number(id));
      }
      else
      {
        indextask = ganttDataUtilsService.tasks.findIndex((x: any) => x.id === id);
      }
      if (indextask >= 0)
      {
        ganttDataUtilsService.tasks[indextask].a_due_date = gantt.getTask(id).a_due_date;
        ganttDataUtilsService.tasks[indextask].a_start_date = gantt.getTask(id).a_start_date;
        ganttDataUtilsService.tasks[indextask].b_due_date = gantt.getTask(id).b_due_date;
        ganttDataUtilsService.tasks[indextask].b_due_date_cfvId =
          gantt.getTask(id).b_due_date_cfvId;
        ganttDataUtilsService.tasks[indextask].b_estimate_cfvId =
          gantt.getTask(id).b_estimate_cfvId;
        ganttDataUtilsService.tasks[indextask].b_estimated = gantt.getTask(id).b_estimated;
        ganttDataUtilsService.tasks[indextask].b_start_date = gantt.getTask(id).b_start_date;
        ganttDataUtilsService.tasks[indextask].b_start_date_cfvId =
          gantt.getTask(id).b_start_date_cfvId;
        ganttDataUtilsService.tasks[indextask].duration = gantt.getTask(id).duration;
        ganttDataUtilsService.tasks[indextask].end_date = gantt.getTask(id).end_date;
        ganttDataUtilsService.tasks[indextask].estimate = gantt.getTask(id).estimate;
        ganttDataUtilsService.tasks[indextask].start_date = gantt.getTask(id).start_date;
        ganttDataUtilsService.tasks[indextask].status = gantt.getTask(id).status;
      }
    }
  }
}

export default ganttDataUtilsService;
